import React from "react";
import './ImgZoom.scss';

const ImgZoom = (props) => {
   
    const handleCloseImgZoom = () => {
        props.onHandleClose();
    }

    return (
        <div className="ImgZoom">
            <div className='img-container'>
                <img alt="note" src={props.noteImgSrc} onClick={handleCloseImgZoom}/>
             </div>
        </div>
    )
}
export default ImgZoom;